module.exports = __webpack_public_path__ + "static/media/cubeVid.73279574.mp4";